import React from "react";
import { SubscriptionRoutes } from "../Routes/SubscriptionRoutes";
const SubscriptionHome = () => {
  return (
    <div>
      <SubscriptionRoutes />
    </div>
  );
}

export default SubscriptionHome;